const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed';

export function getSidebarCollapsed(): boolean {
    try {
        const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
        return saved !== null ? JSON.parse(saved) : false;
    } catch (error) {
        console.warn("Could not load sidebar collapsed state from localStorage", error);
        return false;
    }
}

export function setSidebarCollapsed(isCollapsed: boolean): void {
    try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(isCollapsed));
    } catch (error) {
        console.warn("Could not save sidebar collapsed state to localStorage", error);
    }
}
